export enum RegionalPlan {
  'EU863-870' = 'EU868',
  'US902-928' = 'US915',
  'CN779-787' = 'CN779',
  'EU433' = 'EU433',
  'AU915-928' = 'AU915',
  'CN470-510' = 'CN470',
  'AS923-1' = 'AS923',
  'AS923-2' = 'AS923-2',
  'AS923-3' = 'AS923-3',
  'KR920-923' = 'KR920',
  'IN865-867' = 'IN865',
  'RU864-870' = 'RU864',
  'AS923-4' = 'AS923-4',
}

export enum RegionalParameterRevision {
  'LoRaWAN® v1.0.1' = 'LoRaWAN® v1.0.1',
  'Regional Parameters v1.0.2rB' = 'Regional Parameters v1.0.2rB',
  'Regional Parameters v1.0.3rA' = 'Regional Parameters v1.0.3rA',
  'Regional Parameters v1.1rA' = 'Regional Parameters v1.1rA',
  'RP002-1.0.0' = 'RP002-1.0.0',
  'RP002-1.0.1' = 'RP002-1.0.1',
  'RP002-1.0.2' = 'RP002-1.0.2',
  'RP002-1.0.3' = 'RP002-1.0.3',
}
